import { z } from 'zod';

import { GlobalApiCountrySchema } from './country';

export const InstitutionAssetsSchema = z.object({
  icon: z.string().url().nullable(),
  logo: z.string().url().nullable(),
});

export const InstitutionCapabilitiesSchema = z.object({
  payments: z.object({
    active: z.boolean(),
    accountIdentifiersRequired: z.array(z.string()),
    additionalDataRequired: z.array(z.any()),
    communication: z.object({
      appToApp: z.enum(['SUPPORTED', 'UNKNOWN', 'NOT_SUPPORTED']).optional(),
    }),
  }),
});

export const InstitutionBranchSchema = z.object({
  localName: z.string().nullable(),
  name: z.string().nullable(),
});

export const InstitutionGroupSchema = z.object({
  name: z.string().nullable(),
  localName: z.string().nullable(),
});

export const InstitutionBankTypesSchema = z.array(
  z.enum(['BUSINESS', 'PERSONAL'])
);

export const GlobalApiInstitutionDetailsSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
    localName: z.string().nullable(),
    alternativeName: z.string().nullable(),
    group: InstitutionGroupSchema,
    branch: InstitutionBranchSchema,
    nationalId: z.string().nullable(),
    assets: InstitutionAssetsSchema,
    types: InstitutionBankTypesSchema,
    capabilities: InstitutionCapabilitiesSchema,
  })
  .merge(GlobalApiCountrySchema);

export const GlobalApiInstitutionListItemSchema = z
  .object({
    supportedCurrencies: z
      .array(z.string().length(3, 'Currency should have 3 characters'))
      .optional(),
  })
  .merge(GlobalApiInstitutionDetailsSchema);

export const GlobalApiInstitutionsListSchema = z.array(
  GlobalApiInstitutionListItemSchema
);
